<template>
    <div class="find-a-doctor-card card" :data-swiftype-id="data.id">
        <div class="find-a-doctor-card__inner">
            <div class="find-a-doctor-card__top">
                <a :href="`/${data.url}`" class="find-a-doctor-card__image-wrapper" @click="handleClick('profile_image', $event)">
                    <img :src="data.image" class="find-a-doctor-card__image" :alt="data.alt" v-if="data.image">
                    <span class="find-a-doctor-card__link">View Profile</span>
                </a>

                <div class="find-a-doctor-card__info">
                    <a :href="`/${data.url}`" class="find-a-doctor-card__heading" @click="handleClick('name', $event)">{{ data.title }}</a>

                    <div class="find-a-doctor-card__title">{{ data.position }}</div>

                    <div class="find-a-doctor-card__subtitle" v-if="data.additional_titles">{{ data.additional_titles }}</div>

                    <div class="find-a-doctor-card__address" v-html="address" />

                    <a href="/locations" class="find-a-doctor-card__locations-link" v-if="data.locations.length > 1" @click="handleClick('locations', $event)">
                        View All Locations
                    </a>
                </div>
            </div>
            <div class="find-a-doctor-card__bottom">
                <div class="find-a-doctor-card__actions">
                    <template v-if="data.accepting_appointments">
                        <a
                            :href="`/request-an-appointment${data.craft_id ? '?provider=' + data.craft_id : ''}`"
                            class="find-a-doctor-card__button button"
                            @click="handleClick('request_an_appointment', $event)"
                        >
                            Request an Appointment
                        </a>
                    </template>
                    <a
                        :href="`tel:+${data.phone_number}`"
                        class="find-a-doctor-card__phone-number"
                        v-if="data.phone_number"
                        @click="handleClick('phone_number', $event)"
                    >
                        {{ data.phone_number }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import client from '../../../scripts/swiftypeClient.js';

export default {
    name: 'personnel',
    props: ['data', 'requestId'],
    methods: {
        handleClick(type, e) {
            const tags = [];

            if (Object.keys(this.filters).length) {
                Object.keys(this.filters).forEach((filter) => {
                    if (this.filters[filter]) {
                        tags.push(`${filter}: ${this.filters[filter]}`);
                    }
                });

                tags.push(`type: ${type}`);
            } else {
                tags.push(type);
            }

            client.click({
                query: '',
                documentId: this.data.id,
                requestId: this.requestId,
                tags,
            });
        },
    },
    computed: {
        ...mapGetters(['filters']),
        address() {
            const location = this.data.locations.length ? this.data.locations[0] : null;
            let address = '';

            if (this.data.display_address) {
                address = `<strong>${location}</strong><br>${this.data.display_address}<br>`;
            } else if (this.data.address_parts) {
                let parts = JSON.parse(this.data.address_parts);

                if (location && parts) {

                    address = `<strong>${location}</strong><br>${parts.street_number || parts.number} ${parts.route || parts.address}<br>`;

                    if (parts.suite) {
                        address += `${parts.suite}<br>`;
                    }

                    address += `${parts.locality || parts.city}, ${parts.administrative_area_level_1 || parts.state }, ${parts.postal_code || parts.postcode}`
                }
            }

            return address;
        }
    }
}
</script>
